/**
 * Safety net per Sami Wholesale loader stuck.
 *
 * Sami aggiunge classe `samita-ws-loading` durante il calcolo dei
 * prezzi B2B. Se la chiamata API fallisce o non risponde, la classe
 * resta e i prezzi restano nascosti (visibility:hidden) per sempre.
 *
 * Questo script rimuove forzatamente la classe dopo 6 secondi sia
 * dall'html che dal body, garantendo che i prezzi del tema (server-
 * rendered) tornino visibili. Se Sami funziona, ha tutto il tempo
 * di completare prima e questo fallback non fa nulla di visibile.
 *
 * NON tocca i prezzi stessi: Sami ha gia' aggiornato il DOM con i
 * prezzi B2B quando funziona, oppure restano quelli del tema.
 */
(function () {
  var removed = false;
  function removeStuckLoading() {
    if (removed) return;
    var html = document.documentElement;
    var body = document.body;
    if (!body) return;
    if (html.classList.contains('samita-ws-loading') ||
        body.classList.contains('samita-ws-loading')) {
      html.classList.remove('samita-ws-loading');
      body.classList.remove('samita-ws-loading');
      // Anche eventuali container interni
      var stuck = document.querySelectorAll('.samita-ws-loading');
      for (var i = 0; i < stuck.length; i++) {
        stuck[i].classList.remove('samita-ws-loading');
      }
      removed = true;
      // Telemetria minimale per debug
      if (window.console && console.warn) {
        console.warn('[IDTPRO] Sami Wholesale loader rimosso dopo timeout (6s). Verifica configurazione app B2B.');
      }
    }
  }

  // Listener: appena Sami completa, marca come "ok" cosi' non rimuoviamo nulla.
  document.addEventListener('samitaWSRenderWholesaleCompleted', function () {
    removed = true;
  });

  // Fallback timeout. 6 secondi sono abbondanti: in condizioni
  // normali Sami completa in 500-1500ms.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(removeStuckLoading, 6000);
    });
  } else {
    setTimeout(removeStuckLoading, 6000);
  }
})();
